export default "__VITE_ASSET__DBkvQMgk__"